<template>
  <div class="page-wrapper">
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li>
          <a @click="arrow.isFirstPage ? () => {return;} : changePage(1)" aria-label="Previous">
          <span aria-hidden="true">
            <i
                class="fa-regular fa-arrow-left-to-line"
                :class="arrow.isFirstPage ? 'inactive' : ''"
            />
          </span>
          </a>
        </li>
        <li>
          <a @click="arrow.isFirstBlock ? () => {return} : changeBlock(PageDirectionEnum.PREVIOUS)" aria-label="Previous">
          <span aria-hidden="true">
            <i
                class="fa-regular fa-arrow-left"
                aria-hidden="true"
                :class="arrow.isFirstBlock ? 'inactive' : ''"
            />
          </span>
          </a>
        </li>
        <li
            v-for="pNum in pageList"
            :class="[pageInfo.currentPage === pNum ? 'active' : '']"
        >
          <a @click="changePage(pNum)">{{ pNum }}</a>
        </li>
        <li>
          <a @click="arrow.isLastBlock ? () => {return} : changeBlock(PageDirectionEnum.NEXT)" aria-label="Next">
          <span aria-hidden="true">
            <i
              class="fa-regular fa-arrow-right"
              aria-hidden="true"
              :class="arrow.isLastBlock ? 'inactive' : ''"
            />
          </span>
          </a>
        </li>
        <li>
          <a @click="arrow.isLastPage ? () => {return} : changePage(pageInfo.totalPages)" aria-label="NextNext">
          <span aria-hidden="true">
            <i
              class="fa-regular fa-arrow-right-to-line"
              :class="arrow.isLastPage ? 'inactive' : ''"
            />
          </span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>

const readOnly = {
  event: {
    ChangePage: "ChangePage",
  }
}
const PageDirectionEnum = {
  PREVIOUS: 'prev',
  NEXT: 'next'
}
export default {
  props: {
    pagePerBlock: {
      type: Number,
      required: false,
    },
    pageInfo: {
      type: Object,
      default: {currentPage: 1, totalPages: 0}
    },
    pageName: {
      type: String,
      default: '',
    },
    
  },
  emits: Object.keys(readOnly.event),
  computed: {
    arrow() {
      const lastPageInBlock = Math.ceil(this.pageInfo.currentPage / this.pageListSize) * this.pageListSize;
      return {
        isFirstPage: this.pageInfo.currentPage === 1,
        isFirstBlock: this.pageInfo.currentPage <= this.pageListSize,
        isLastPage: this.pageInfo.currentPage === this.pageInfo.totalPages,
        isLastBlock: lastPageInBlock >= this.pageInfo.totalPages
      }
    },
    pageList() {
      const startPage = Math.floor((this.pageInfo.currentPage - 1) / this.pageListSize) * this.pageListSize + 1;
      const endPage = startPage + this.pageListSize - 1 > this.pageInfo.totalPages ? this.pageInfo.totalPages : startPage + this.pageListSize - 1
      return Array.from({length: endPage - startPage + 1}, (_, i) => startPage + i);
    }
  },
  data() {
    return {
      PageDirectionEnum,
      pageListSize: 10,
    };
  },
  created() {
    const mediaQuery = window.matchMedia('(max-width: 750px)');

    const handleChangePagination = (mediaQuery) => {
      if(this.pagePerBlock) {
        this.pageListSize = this.pagePerBlock;
        return;
      }
      if (mediaQuery.matches) {
        // mediaQuery가 해당될 때 rowsPerPage 값을 5로 변경
        this.pageListSize = 5;
      } else {
        // mediaQuery가 해당되지 않을 때 rowsPerPage 값을 10으로 변경 (기존 선언된 값)
        this.pageListSize = 10;
      }
    };
    // 초기 값으로 한 번 호출하여 현재 mediaQuery에 대한 상태를 확인
    handleChangePagination(mediaQuery);

    // mediaQuery에 대한 변경 감지 이벤트 리스너 등록
    mediaQuery.addListener(handleChangePagination);
  },
  async mounted() {
  },
  methods: {
    changeBlock(pageDirection) {
      if (this.pageInfo.totalPages <= this.pageListSize) return;
      let pageNum;
      if (pageDirection === PageDirectionEnum.PREVIOUS) {
        pageNum = this.getFirstPage().prevBlock();
      } else if (pageDirection === PageDirectionEnum.NEXT) {
        pageNum = this.getFirstPage().nextBlock();
      } else {
        console.error('Invalid direction for changeBlock');
        return;
      }
      this.changePage(pageNum);
    },
    changePage(pageNum) {
      this.$emit(readOnly.event.ChangePage, {page: pageNum, pageType: this.pageName});
    },
    getFirstPage() {
      const pageSize = this.pageListSize;
      const currentPage = this.pageInfo.currentPage;
      let prevBlockFirstPage = Math.floor((currentPage - 1) / pageSize) * pageSize - pageSize + 1;
      return {
        prevBlock: () => prevBlockFirstPage === 0 ? 1 : prevBlockFirstPage,
        nextBlock: () => Math.floor((currentPage - 1) / pageSize) * pageSize + pageSize + 1,
      }
    }
  },
};
</script>
<style lang="scss" scoped>

$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$CertiBlue : #278AEC;
$Font-medium: 500;
$Font-regular: 400;
$Font-semibold: 600;
$Font-bold: 700;
$Font-extrabold: 800;
$Font-heavy: 900;

.page-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}


//페이지네이션//
.pagination {
  max-width: 1400px;
  display: flex;
  justify-content: center;

  .active a {
      color: $Gray-100;
      background-color: #ffe414 !important;
      font-weight: 600;
      padding: 8px;
      border-radius: 6px;

      &:hover {
          background-color: #ffe414 !important;

          border: 0px;
      }

      // &:focus {
      //     background-color: transparent;
      //     color: #143361;
      //     outline: none;
      // }
  }

  li {


      margin-right: 2px;
      min-width: 32px;
      text-align: center;
      min-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
  }


  li a {
      border: 1px;
      margin-left: 0px;
      color: $Gray-80;
      padding: 8px;
      min-width: 32px;
      max-height: 32px;
      font-size: 16px;
      cursor: pointer;
      line-height: 16px;
      font-weight: 500;


      &:hover {
          background-color: #e4e7eb !important;
          padding: 8px;
          border-radius: 6px;

          //padding: 1px;
          //margin: 5px 25px;
      }

      &:focus {
          color: #143361;
          background-color: #ffe414;
          font-weight: 600;
          padding: 5px 10px;
          border-radius: 100%;
      }

      span {
          .inactive {
              opacity: 0.4;
          }
      }
  }



  li:first-child a,
  li:last-child a {

      margin: 0px;

      font-size: 16px;
      color: #143361;

      &:hover {
          text-decoration: none !important;
          // color: #fff;
          background-color: #143361;
      }

      &:focus {
          outline: none;
      }

      i {
          font-size: 16px;
      }
  }

  li:nth-child(2) {
      margin-right: 12px;
  }

  li:nth-last-child(2) {
      margin-left: 12px;
  }

}
</style>